import { render, staticRenderFns } from "./MappingTable.vue?vue&type=template&id=b1f59512&"
import script from "./MappingTable.vue?vue&type=script&lang=js&"
export * from "./MappingTable.vue?vue&type=script&lang=js&"
import style0 from "./MappingTable.vue?vue&type=style&index=0&id=b1f59512&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports